import { ForbiddenError, HttpStatusCodes, Inject, Result } from '@resourceful-hono/core';
import { Permissions } from '../../../services/OAuth/enums.ts';
import { BaseResource } from '../BaseResource.ts';
import { Protected } from '../common/decorators.ts';
import { Game } from '../../../entities/Game.ts';
import { TransactionsResource } from '../Transactions/index.ts';
import { User } from '../../../entities/index.ts';
import { GameEvent } from '../common/events.ts';
import { DataSourceTransactionScope } from '../../../common/datasource-transaction-scope.ts';
import { EventService } from '../../../services/Events.ts';

export class GameResource extends BaseResource {
  @Inject()
  declare private readonly gameEvents: EventService;

  @Protected([Permissions.GetGame])
  public async GET() {
    const user = await this.user;
    if (!user.game)
      throw new ForbiddenError('You need to be in a game.');

    const game = await Game.findOne({
      where: { id: user.game.id },
      relations: {
        players: {
          account: true,
        },
      },
    });
    return Result(HttpStatusCodes.Ok, game);
  }

  @Protected([Permissions.PostGame])
  public async POST() {
    const user = await User.findOne({
      where: {
        id: this.userId,
      },
      relations: {
        account: true,
        game: true,
      },
    });
    if (!user) throw new ForbiddenError();
    if (user.game)
      throw new ForbiddenError('You are already in a game.');

    await using scope = await DataSourceTransactionScope.create();
    user.game = scope.queryRunner.manager.create(Game, {
      players: [user],
    });

    await scope.queryRunner.manager.save(user);
    await TransactionsResource.transferStartingCapital(user);

    // publish to client
    this.gameEvents.dispatchEvent(
      new GameEvent({
        gameId: user.game.id,
        target: [this.route],
      })
    );

    scope.complete();
    return Result(HttpStatusCodes.Created, user.game);
  }
}